// UsernamesContext.js

import React from 'react';

const UsernamesContext = React.createContext();

export default UsernamesContext;
